import CompareResumesEditing from './compare-resumes-editing';
import { Plugin } from '@ckeditor/ckeditor5-core';
import './styles.css';
class CompareResumesUI extends Plugin {
    init() { }
}
export default class CompareResumes extends Plugin {
    static get requires() {
        return [CompareResumesEditing, CompareResumesUI];
    }
}
